import styled from 'styled-components';
import { FlexSpacer } from 'ui/flexSpacer';
import { Body2, colors, spacing } from 'ui/theme';

const StyledBody2 = styled(Body2)`
  color: ${colors.textSecondary};
 text-decoration: underline dashed;
`;

const StyledNumber = styled.h1`
 margin-top: ${spacing.half};
`;

export const InsightsSummary = ({
  totalSends,
  totalUnique,
}: { totalSends?: number; totalUnique?: number }) => {
  // Separate numbers with commas
  const numberFormatter = new Intl.NumberFormat('en-US');
  return (
    <FlexSpacer data-test="insights-summary">
      {!!totalUnique && (
        <div>
          <StyledBody2>Unique emails delivered</StyledBody2>
          <StyledNumber>{numberFormatter.format(totalUnique)}</StyledNumber>
        </div>
      )}
      {!!totalSends && (
        <div>
          <StyledBody2>Total sent messages</StyledBody2>
          <StyledNumber>{numberFormatter.format(totalSends)}</StyledNumber>
        </div>
      )}
    </FlexSpacer>
  );
};
